import { useState, useLayoutEffect } from 'react';

const DEFAULT_OFFSET = 300;

interface IuseDynamicGridHeightProps {
  gridItems: any[] | null;
  offset?: number;
}

interface IuseDynamicGridHeightReturn {
  gridHeight: number;
}

export const useDynamicGridHeight = (props: IuseDynamicGridHeightProps) : IuseDynamicGridHeightReturn => {
  
  const offset = props.offset || DEFAULT_OFFSET;
  const [gridHeight, setGridHeight] = useState(window.innerHeight - offset);

  useLayoutEffect(() => {
    
    // Calculate grid height
    const handleResize = () => {
      const gridHeight = window.innerHeight - DEFAULT_OFFSET;      
      setGridHeight(gridHeight);
      // console.log(`grid resize: ${gridHeight}`);
    };
  
    // Update height on resize
    window.addEventListener('resize', handleResize);
  
    // Handle initial height
    handleResize();
  
    // Cleanup
    return () => { window.removeEventListener('resize', handleResize); };
  
  }, [props.gridItems]);

  return { gridHeight };
};